export default "6d9b7fab1a654d19.png"